var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello bgWhite"},[_c('h1',[_vm._v("欢迎访问国土规划院廉政小系统后台管理系统")])])}]

export { render, staticRenderFns }